import { jsxs, jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useRef, useState, Children, useEffect, Fragment } from "react";
import { clsx } from "clsx";
import { useGraphiQLActions, pick, useGraphiQL, useMonaco, useGraphiQLSettings, useDragResize, ChevronUpIcon, ChevronDownIcon, Tab, Tooltip, PortalProvider, GraphiQLProvider, QueryEditor, Spinner, UnStyledButton, VarHeadersStrip, TopBar, SidePanel, Tabs, PlusIcon, PrettifyIcon, MergeIcon, CopyIcon, SaveIcon, ResponseEditor, StatusBar } from "@graphiql/react";
import { HISTORY_PLUGIN, HistoryStore } from "@graphiql/plugin-history";
import { DOC_EXPLORER_PLUGIN, DocExplorerStore } from "@graphiql/plugin-doc-explorer";
import { QUERY_BUILDER_PLUGIN } from "@graphiql/plugin-query-builder";
import { collectionsPlugin } from "@graphiql/plugin-collections";
import { GraphiQLFooter } from "./ui/footer.js";
import { ActivityBar } from "./ui/activity-bar.js";
const DEFAULT_PLUGINS = [HISTORY_PLUGIN, QUERY_BUILDER_PLUGIN, collectionsPlugin()];
const GraphiQL_ = (t0) => {
  const $ = c(54);
  let brand;
  let children;
  let className;
  let confirmCloseTab;
  let defaultEditorToolsVisibility;
  let forcedTheme;
  let isHeadersEditorEnabled;
  let maxHistoryLength;
  let onEditHeaders;
  let onEditQuery;
  let onEditVariables;
  let props;
  let responseTooltip;
  let showPersistHeadersSettings;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      maxHistoryLength,
      plugins: t1,
      referencePlugin: t2,
      onEditQuery,
      onEditVariables,
      onEditHeaders,
      responseTooltip,
      defaultEditorToolsVisibility,
      isHeadersEditorEnabled,
      showPersistHeadersSettings,
      forcedTheme,
      confirmCloseTab,
      className,
      brand,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = brand;
    $[2] = children;
    $[3] = className;
    $[4] = confirmCloseTab;
    $[5] = defaultEditorToolsVisibility;
    $[6] = forcedTheme;
    $[7] = isHeadersEditorEnabled;
    $[8] = maxHistoryLength;
    $[9] = onEditHeaders;
    $[10] = onEditQuery;
    $[11] = onEditVariables;
    $[12] = props;
    $[13] = responseTooltip;
    $[14] = showPersistHeadersSettings;
    $[15] = t1;
    $[16] = t2;
  } else {
    brand = $[1];
    children = $[2];
    className = $[3];
    confirmCloseTab = $[4];
    defaultEditorToolsVisibility = $[5];
    forcedTheme = $[6];
    isHeadersEditorEnabled = $[7];
    maxHistoryLength = $[8];
    onEditHeaders = $[9];
    onEditQuery = $[10];
    onEditVariables = $[11];
    props = $[12];
    responseTooltip = $[13];
    showPersistHeadersSettings = $[14];
    t1 = $[15];
    t2 = $[16];
  }
  const plugins = t1 === void 0 ? DEFAULT_PLUGINS : t1;
  const referencePlugin = t2 === void 0 ? DOC_EXPLORER_PLUGIN : t2;
  if (props.keyMap) {
    throw new TypeError("`keyMap` was removed. To use Vim or Emacs keybindings in Monaco, you can use community plugins. Monaco Vim: https://github.com/brijeshb42/monaco-vim. Monaco Emacs: https://github.com/aioutecism/monaco-emacs");
  }
  if (props.readOnly) {
    throw new TypeError("The `readOnly` prop has been removed.");
  }
  const t3 = showPersistHeadersSettings ?? props.shouldPersistHeaders !== false;
  let t4;
  if ($[17] !== brand || $[18] !== className || $[19] !== confirmCloseTab || $[20] !== defaultEditorToolsVisibility || $[21] !== forcedTheme || $[22] !== isHeadersEditorEnabled || $[23] !== onEditHeaders || $[24] !== onEditQuery || $[25] !== onEditVariables || $[26] !== responseTooltip || $[27] !== t3) {
    t4 = {
      showPersistHeadersSettings: t3,
      onEditQuery,
      onEditVariables,
      onEditHeaders,
      responseTooltip,
      defaultEditorToolsVisibility,
      isHeadersEditorEnabled,
      forcedTheme,
      confirmCloseTab,
      className,
      brand
    };
    $[17] = brand;
    $[18] = className;
    $[19] = confirmCloseTab;
    $[20] = defaultEditorToolsVisibility;
    $[21] = forcedTheme;
    $[22] = isHeadersEditorEnabled;
    $[23] = onEditHeaders;
    $[24] = onEditQuery;
    $[25] = onEditVariables;
    $[26] = responseTooltip;
    $[27] = t3;
    $[28] = t4;
  } else {
    t4 = $[28];
  }
  const interfaceProps = t4;
  let t5;
  if ($[29] !== plugins) {
    t5 = plugins.includes(HISTORY_PLUGIN);
    $[29] = plugins;
    $[30] = t5;
  } else {
    t5 = $[30];
  }
  const hasHistoryPlugin = t5;
  const HistoryToUse = hasHistoryPlugin ? HistoryStore : Fragment;
  const DocExplorerToUse = referencePlugin === DOC_EXPLORER_PLUGIN ? DocExplorerStore : Fragment;
  let t6;
  if ($[31] !== referencePlugin) {
    t6 = referencePlugin ? [referencePlugin] : [];
    $[31] = referencePlugin;
    $[32] = t6;
  } else {
    t6 = $[32];
  }
  let t7;
  if ($[33] !== plugins || $[34] !== t6) {
    t7 = [...t6, ...plugins];
    $[33] = plugins;
    $[34] = t6;
    $[35] = t7;
  } else {
    t7 = $[35];
  }
  let t8;
  if ($[36] !== hasHistoryPlugin || $[37] !== maxHistoryLength) {
    t8 = hasHistoryPlugin && {
      maxHistoryLength
    };
    $[36] = hasHistoryPlugin;
    $[37] = maxHistoryLength;
    $[38] = t8;
  } else {
    t8 = $[38];
  }
  let t9;
  if ($[39] !== children || $[40] !== interfaceProps) {
    t9 = /* @__PURE__ */ jsx(GraphiQLInterface, { ...interfaceProps, children });
    $[39] = children;
    $[40] = interfaceProps;
    $[41] = t9;
  } else {
    t9 = $[41];
  }
  let t10;
  if ($[42] !== DocExplorerToUse || $[43] !== t9) {
    t10 = /* @__PURE__ */ jsx(DocExplorerToUse, { children: t9 });
    $[42] = DocExplorerToUse;
    $[43] = t9;
    $[44] = t10;
  } else {
    t10 = $[44];
  }
  let t11;
  if ($[45] !== HistoryToUse || $[46] !== t10 || $[47] !== t8) {
    t11 = /* @__PURE__ */ jsx(HistoryToUse, { ...t8, children: t10 });
    $[45] = HistoryToUse;
    $[46] = t10;
    $[47] = t8;
    $[48] = t11;
  } else {
    t11 = $[48];
  }
  let t12;
  if ($[49] !== props || $[50] !== referencePlugin || $[51] !== t11 || $[52] !== t7) {
    t12 = /* @__PURE__ */ jsx(GraphiQLProvider, { plugins: t7, referencePlugin, ...props, onSaveQuery: props.onSaveQuery, children: t11 });
    $[49] = props;
    $[50] = referencePlugin;
    $[51] = t11;
    $[52] = t7;
    $[53] = t12;
  } else {
    t12 = $[53];
  }
  return t12;
};
const TAB_CLASS_PREFIX = "graphiql-session-tab-";
const LABEL = {
  newTab: "New tab",
  prettify: "Prettify query",
  merge: "Merge fragments into query",
  copy: "Copy query",
  save: "Save query"
};
const GraphiQLInterface = (t0) => {
  const $ = c(158);
  const {
    forcedTheme,
    defaultEditorToolsVisibility,
    isHeadersEditorEnabled: t1,
    children: $children,
    confirmCloseTab,
    className,
    onEditQuery,
    onEditVariables,
    onEditHeaders,
    responseTooltip,
    showPersistHeadersSettings,
    brand
  } = t0;
  const isHeadersEditorEnabled = t1 === void 0 ? true : t1;
  const {
    addTab,
    moveTab,
    closeTab,
    changeTab,
    setVisiblePlugin,
    saveQuery,
    copyQuery,
    prettifyEditors,
    mergeQuery
  } = useGraphiQLActions();
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = pick("initialVariables", "initialHeaders", "tabs", "activeTabIndex", "visiblePlugin", "operations", "plugins", "saveHandlers", "onSaveQuery");
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    initialVariables,
    initialHeaders,
    tabs,
    activeTabIndex,
    visiblePlugin,
    operations,
    plugins,
    saveHandlers,
    onSaveQuery
  } = useGraphiQL(t2);
  const canSave = saveHandlers.size > 0 || Boolean(onSaveQuery);
  const hasMonaco = useMonaco(_temp);
  const containerRef = useRef(null);
  const [portalContainer, setPortalContainer] = useState(null);
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = (node) => {
      containerRef.current = node;
      setPortalContainer(node);
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const setContainerRef = t3;
  useGraphiQLSettings(containerRef);
  const t4 = visiblePlugin ? void 0 : "first";
  let t5;
  if ($[2] !== setVisiblePlugin || $[3] !== t4) {
    t5 = {
      defaultSizeRelation: 0.3333333333333333,
      direction: "horizontal",
      initiallyHidden: t4,
      onHiddenElementChange(resizableElement) {
        if (resizableElement === "first") {
          setVisiblePlugin(null);
        }
      },
      sizeThresholdSecond: 200,
      storageKey: "docExplorerFlex"
    };
    $[2] = setVisiblePlugin;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const {
    hiddenElement: pluginHiddenElement,
    setHiddenElement: setPluginHiddenElement,
    firstRef: pluginFirstRef,
    dragBarRef: pluginDragBarRef,
    secondRef: pluginSecondRef
  } = useDragResize(t5);
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      direction: "horizontal",
      storageKey: "editorFlex"
    };
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const {
    firstRef: editorFirstRef,
    dragBarRef: editorDragBarRef,
    secondRef: editorSecondRef
  } = useDragResize(t6);
  let t7;
  if ($[6] !== initialHeaders || $[7] !== initialVariables) {
    t7 = (d) => {
      if (d === "variables" || d === "headers") {
        return;
      }
      if (typeof d === "boolean") {
        return d ? void 0 : "second";
      }
      return initialVariables || initialHeaders ? void 0 : "second";
    };
    $[6] = initialHeaders;
    $[7] = initialVariables;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== defaultEditorToolsVisibility || $[10] !== t7) {
    t8 = t7(defaultEditorToolsVisibility);
    $[9] = defaultEditorToolsVisibility;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t8) {
    t9 = {
      defaultSizeRelation: 3,
      direction: "vertical",
      initiallyHidden: t8,
      sizeThresholdSecond: 60,
      storageKey: "secondaryEditorFlex"
    };
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const {
    hiddenElement: editorToolsHiddenElement,
    setHiddenElement: setEditorToolsHiddenElement,
    firstRef: editorToolsFirstRef,
    dragBarRef: editorToolsDragBarRef,
    secondRef: editorToolsSecondRef
  } = useDragResize(t9);
  let t10;
  if ($[14] !== $children) {
    t10 = Children.toArray($children).reduce(_temp2, {
      children: []
    });
    $[14] = $children;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const {
    footer,
    children
  } = t10;
  let t11;
  let t12;
  if ($[16] !== pluginHiddenElement || $[17] !== setPluginHiddenElement || $[18] !== visiblePlugin) {
    t11 = () => {
      if (visiblePlugin && pluginHiddenElement === "first") {
        setPluginHiddenElement(null);
      }
    };
    t12 = [visiblePlugin, pluginHiddenElement, setPluginHiddenElement];
    $[16] = pluginHiddenElement;
    $[17] = setPluginHiddenElement;
    $[18] = visiblePlugin;
    $[19] = t11;
    $[20] = t12;
  } else {
    t11 = $[19];
    t12 = $[20];
  }
  useEffect(t11, t12);
  let t13;
  if ($[21] !== editorToolsHiddenElement || $[22] !== setEditorToolsHiddenElement) {
    t13 = () => {
      setEditorToolsHiddenElement(editorToolsHiddenElement === "second" ? null : "second");
    };
    $[21] = editorToolsHiddenElement;
    $[22] = setEditorToolsHiddenElement;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  const toggleEditorTools = t13;
  let t14;
  if ($[24] !== closeTab || $[25] !== confirmCloseTab) {
    t14 = async (event) => {
      const tabButton = event.currentTarget.previousSibling;
      const index = Number(tabButton.id.replace(TAB_CLASS_PREFIX, ""));
      const shouldCloseTab = confirmCloseTab ? await confirmCloseTab(index) : true;
      if (!shouldCloseTab) {
        return;
      }
      closeTab(index);
    };
    $[24] = closeTab;
    $[25] = confirmCloseTab;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  const handleTabClose = t14;
  let t15;
  if ($[27] !== changeTab) {
    t15 = (event_0) => {
      const index_0 = Number(event_0.currentTarget.id.replace(TAB_CLASS_PREFIX, ""));
      changeTab(index_0);
    };
    $[27] = changeTab;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  const handleTabClick = t15;
  const editorToolsText = `${editorToolsHiddenElement === "second" ? "Show" : "Hide"} editor tools`;
  const EditorToolsIcon = editorToolsHiddenElement === "second" ? ChevronUpIcon : ChevronDownIcon;
  let t16;
  if ($[29] !== hasMonaco || $[30] !== onEditQuery) {
    t16 = hasMonaco ? /* @__PURE__ */ jsx(QueryEditor, { onEdit: onEditQuery }) : /* @__PURE__ */ jsx(Spinner, {});
    $[29] = hasMonaco;
    $[30] = onEditQuery;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== editorToolsFirstRef || $[33] !== t16) {
    t17 = /* @__PURE__ */ jsx("section", { className: "graphiql-query-editor", "aria-label": "Operation Editor", ref: editorToolsFirstRef, children: t16 });
    $[32] = editorToolsFirstRef;
    $[33] = t16;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== EditorToolsIcon) {
    t18 = /* @__PURE__ */ jsx(EditorToolsIcon, { className: "graphiql-chevron-icon", "aria-hidden": "true" });
    $[35] = EditorToolsIcon;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== editorToolsText || $[38] !== t18 || $[39] !== toggleEditorTools) {
    t19 = /* @__PURE__ */ jsx(UnStyledButton, { type: "button", onClick: toggleEditorTools, "aria-label": editorToolsText, className: "graphiql-toggle-editor-tools", children: t18 });
    $[37] = editorToolsText;
    $[38] = t18;
    $[39] = toggleEditorTools;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== editorToolsText || $[42] !== t19) {
    t20 = /* @__PURE__ */ jsx(Tooltip, { label: editorToolsText, children: t19 });
    $[41] = editorToolsText;
    $[42] = t19;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  let t21;
  if ($[44] !== editorToolsDragBarRef || $[45] !== t20) {
    t21 = /* @__PURE__ */ jsx("div", { ref: editorToolsDragBarRef, className: "graphiql-editor-tools", children: t20 });
    $[44] = editorToolsDragBarRef;
    $[45] = t20;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== initialHeaders || $[48] !== initialVariables || $[49] !== isHeadersEditorEnabled) {
    t22 = (d_0) => {
      if (d_0 === "variables" || d_0 === "headers") {
        return d_0;
      }
      return !initialVariables && initialHeaders && isHeadersEditorEnabled ? "headers" : "variables";
    };
    $[47] = initialHeaders;
    $[48] = initialVariables;
    $[49] = isHeadersEditorEnabled;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  let t23;
  if ($[51] !== defaultEditorToolsVisibility || $[52] !== t22) {
    t23 = t22(defaultEditorToolsVisibility);
    $[51] = defaultEditorToolsVisibility;
    $[52] = t22;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  let t24;
  if ($[54] !== isHeadersEditorEnabled || $[55] !== onEditHeaders || $[56] !== onEditVariables || $[57] !== t23) {
    t24 = /* @__PURE__ */ jsx(VarHeadersStrip, { defaultTab: t23, headersEditorEnabled: isHeadersEditorEnabled, onEditVariables, onEditHeaders });
    $[54] = isHeadersEditorEnabled;
    $[55] = onEditHeaders;
    $[56] = onEditVariables;
    $[57] = t23;
    $[58] = t24;
  } else {
    t24 = $[58];
  }
  let t25;
  if ($[59] !== editorToolsSecondRef || $[60] !== t24) {
    t25 = /* @__PURE__ */ jsx("section", { className: "graphiql-editor-tool", "aria-label": "Variables and Headers", ref: editorToolsSecondRef, children: t24 });
    $[59] = editorToolsSecondRef;
    $[60] = t24;
    $[61] = t25;
  } else {
    t25 = $[61];
  }
  let t26;
  if ($[62] !== t17 || $[63] !== t21 || $[64] !== t25) {
    t26 = /* @__PURE__ */ jsxs("div", { className: "graphiql-editors", children: [
      t17,
      t21,
      t25
    ] });
    $[62] = t17;
    $[63] = t21;
    $[64] = t25;
    $[65] = t26;
  } else {
    t26 = $[65];
  }
  const editors = t26;
  const tabContainerRef = useRef(null);
  let t27;
  if ($[66] !== className) {
    t27 = clsx("graphiql-container", className);
    $[66] = className;
    $[67] = t27;
  } else {
    t27 = $[67];
  }
  let t28;
  if ($[68] !== brand) {
    t28 = /* @__PURE__ */ jsx(TopBar, { brand });
    $[68] = brand;
    $[69] = t28;
  } else {
    t28 = $[69];
  }
  let t29;
  if ($[70] !== forcedTheme || $[71] !== setPluginHiddenElement || $[72] !== showPersistHeadersSettings) {
    t29 = /* @__PURE__ */ jsx(ActivityBar, { forcedTheme, showPersistHeadersSettings, setHiddenElement: setPluginHiddenElement });
    $[70] = forcedTheme;
    $[71] = setPluginHiddenElement;
    $[72] = showPersistHeadersSettings;
    $[73] = t29;
  } else {
    t29 = $[73];
  }
  let t30;
  if ($[74] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = /* @__PURE__ */ jsx(SidePanel, {});
    $[74] = t30;
  } else {
    t30 = $[74];
  }
  let t31;
  if ($[75] !== pluginFirstRef) {
    t31 = /* @__PURE__ */ jsx("div", { ref: pluginFirstRef, className: "graphiql-plugin", children: t30 });
    $[75] = pluginFirstRef;
    $[76] = t31;
  } else {
    t31 = $[76];
  }
  let t32;
  if ($[77] !== pluginDragBarRef || $[78] !== visiblePlugin) {
    t32 = visiblePlugin && /* @__PURE__ */ jsx("div", { className: "graphiql-horizontal-drag-bar", ref: pluginDragBarRef });
    $[77] = pluginDragBarRef;
    $[78] = visiblePlugin;
    $[79] = t32;
  } else {
    t32 = $[79];
  }
  let t33;
  if ($[80] !== activeTabIndex || $[81] !== canSave || $[82] !== handleTabClick || $[83] !== handleTabClose || $[84] !== operations || $[85] !== tabs) {
    t33 = tabs.map((tab, index_1) => {
      const isActive = index_1 === activeTabIndex;
      const otherOperations = isActive && tab.operationName && operations ? operations.length - 1 : 0;
      const tabTitle = otherOperations > 0 ? `${tab.title} +${otherOperations}` : tab.title;
      return /* @__PURE__ */ jsxs(Tab, { dragConstraints: tabContainerRef, value: tab, isActive, isDirty: canSave && tab.lastSavedQuery !== null && tab.query !== tab.lastSavedQuery, children: [
        /* @__PURE__ */ jsx(Tab.Button, { "aria-controls": "graphiql-session", id: `graphiql-session-tab-${index_1}`, title: tabTitle, onClick: handleTabClick, children: tabTitle }),
        tabs.length > 1 && /* @__PURE__ */ jsx(Tab.Close, { onClick: handleTabClose })
      ] }, tab.id);
    });
    $[80] = activeTabIndex;
    $[81] = canSave;
    $[82] = handleTabClick;
    $[83] = handleTabClose;
    $[84] = operations;
    $[85] = tabs;
    $[86] = t33;
  } else {
    t33 = $[86];
  }
  let t34;
  if ($[87] !== moveTab || $[88] !== t33 || $[89] !== tabs) {
    t34 = /* @__PURE__ */ jsx(Tabs, { ref: tabContainerRef, values: tabs, onReorder: moveTab, "aria-label": "Select active operation", className: "no-scrollbar", children: t33 });
    $[87] = moveTab;
    $[88] = t33;
    $[89] = tabs;
    $[90] = t34;
  } else {
    t34 = $[90];
  }
  let t35;
  if ($[91] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = /* @__PURE__ */ jsx(PlusIcon, { "aria-hidden": "true" });
    $[91] = t35;
  } else {
    t35 = $[91];
  }
  let t36;
  if ($[92] !== addTab) {
    t36 = /* @__PURE__ */ jsx(Tooltip, { label: LABEL.newTab, children: /* @__PURE__ */ jsx(UnStyledButton, { type: "button", className: "graphiql-tab-add", onClick: addTab, "aria-label": LABEL.newTab, children: t35 }) });
    $[92] = addTab;
    $[93] = t36;
  } else {
    t36 = $[93];
  }
  let t37;
  if ($[94] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = /* @__PURE__ */ jsx(PrettifyIcon, { "aria-hidden": "true" });
    $[94] = t37;
  } else {
    t37 = $[94];
  }
  let t38;
  if ($[95] !== prettifyEditors) {
    t38 = /* @__PURE__ */ jsx(Tooltip, { label: LABEL.prettify, children: /* @__PURE__ */ jsx(UnStyledButton, { type: "button", className: "graphiql-tab-strip-action", onClick: prettifyEditors, "aria-label": LABEL.prettify, children: t37 }) });
    $[95] = prettifyEditors;
    $[96] = t38;
  } else {
    t38 = $[96];
  }
  let t39;
  if ($[97] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = /* @__PURE__ */ jsx(MergeIcon, { "aria-hidden": "true" });
    $[97] = t39;
  } else {
    t39 = $[97];
  }
  let t40;
  if ($[98] !== mergeQuery) {
    t40 = /* @__PURE__ */ jsx(Tooltip, { label: LABEL.merge, children: /* @__PURE__ */ jsx(UnStyledButton, { type: "button", className: "graphiql-tab-strip-action", onClick: mergeQuery, "aria-label": LABEL.merge, children: t39 }) });
    $[98] = mergeQuery;
    $[99] = t40;
  } else {
    t40 = $[99];
  }
  let t41;
  if ($[100] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = /* @__PURE__ */ jsx(CopyIcon, { "aria-hidden": "true" });
    $[100] = t41;
  } else {
    t41 = $[100];
  }
  let t42;
  if ($[101] !== copyQuery) {
    t42 = /* @__PURE__ */ jsx(Tooltip, { label: LABEL.copy, children: /* @__PURE__ */ jsx(UnStyledButton, { type: "button", className: "graphiql-tab-strip-action", onClick: copyQuery, "aria-label": LABEL.copy, children: t41 }) });
    $[101] = copyQuery;
    $[102] = t42;
  } else {
    t42 = $[102];
  }
  let t43;
  if ($[103] !== canSave || $[104] !== saveQuery) {
    t43 = canSave && /* @__PURE__ */ jsx(Tooltip, { label: LABEL.save, children: /* @__PURE__ */ jsx(UnStyledButton, { type: "button", className: "graphiql-tab-strip-action", onClick: saveQuery, "aria-label": LABEL.save, children: /* @__PURE__ */ jsx(SaveIcon, { "aria-hidden": "true" }) }) });
    $[103] = canSave;
    $[104] = saveQuery;
    $[105] = t43;
  } else {
    t43 = $[105];
  }
  let t44;
  if ($[106] !== plugins) {
    t44 = plugins.map(_temp3);
    $[106] = plugins;
    $[107] = t44;
  } else {
    t44 = $[107];
  }
  let t45;
  if ($[108] !== t38 || $[109] !== t40 || $[110] !== t42 || $[111] !== t43 || $[112] !== t44) {
    t45 = /* @__PURE__ */ jsxs("div", { className: "graphiql-tab-strip-actions", children: [
      t38,
      t40,
      t42,
      t43,
      t44
    ] });
    $[108] = t38;
    $[109] = t40;
    $[110] = t42;
    $[111] = t43;
    $[112] = t44;
    $[113] = t45;
  } else {
    t45 = $[113];
  }
  let t46;
  if ($[114] !== t34 || $[115] !== t36 || $[116] !== t45) {
    t46 = /* @__PURE__ */ jsxs("div", { className: "graphiql-session-header", children: [
      t34,
      t36,
      t45
    ] });
    $[114] = t34;
    $[115] = t36;
    $[116] = t45;
    $[117] = t46;
  } else {
    t46 = $[117];
  }
  const t47 = `${TAB_CLASS_PREFIX}${activeTabIndex}`;
  let t48;
  if ($[118] !== editors || $[119] !== t47) {
    t48 = /* @__PURE__ */ jsx("div", { role: "region", id: "graphiql-session", "aria-labelledby": t47, children: editors });
    $[118] = editors;
    $[119] = t47;
    $[120] = t48;
  } else {
    t48 = $[120];
  }
  let t49;
  if ($[121] !== editorFirstRef || $[122] !== t46 || $[123] !== t48) {
    t49 = /* @__PURE__ */ jsxs("div", { ref: editorFirstRef, className: "graphiql-editor-column", children: [
      t46,
      t48
    ] });
    $[121] = editorFirstRef;
    $[122] = t46;
    $[123] = t48;
    $[124] = t49;
  } else {
    t49 = $[124];
  }
  let t50;
  if ($[125] !== editorDragBarRef) {
    t50 = /* @__PURE__ */ jsx("div", { className: "graphiql-horizontal-drag-bar", ref: editorDragBarRef });
    $[125] = editorDragBarRef;
    $[126] = t50;
  } else {
    t50 = $[126];
  }
  let t51;
  if ($[127] !== responseTooltip) {
    t51 = /* @__PURE__ */ jsx(ResponseEditor, { responseTooltip });
    $[127] = responseTooltip;
    $[128] = t51;
  } else {
    t51 = $[128];
  }
  let t52;
  if ($[129] !== footer || $[130] !== t51) {
    t52 = /* @__PURE__ */ jsxs("div", { className: "graphiql-response", children: [
      t51,
      footer
    ] });
    $[129] = footer;
    $[130] = t51;
    $[131] = t52;
  } else {
    t52 = $[131];
  }
  let t53;
  if ($[132] !== editorSecondRef || $[133] !== t52) {
    t53 = /* @__PURE__ */ jsx("div", { ref: editorSecondRef, className: "graphiql-response-column", children: t52 });
    $[132] = editorSecondRef;
    $[133] = t52;
    $[134] = t53;
  } else {
    t53 = $[134];
  }
  let t54;
  if ($[135] !== t49 || $[136] !== t50 || $[137] !== t53) {
    t54 = /* @__PURE__ */ jsxs("div", { className: "graphiql-session-row", children: [
      t49,
      t50,
      t53
    ] });
    $[135] = t49;
    $[136] = t50;
    $[137] = t53;
    $[138] = t54;
  } else {
    t54 = $[138];
  }
  let t55;
  if ($[139] !== pluginSecondRef || $[140] !== t54) {
    t55 = /* @__PURE__ */ jsx("div", { ref: pluginSecondRef, className: "graphiql-sessions", children: t54 });
    $[139] = pluginSecondRef;
    $[140] = t54;
    $[141] = t55;
  } else {
    t55 = $[141];
  }
  let t56;
  if ($[142] !== t31 || $[143] !== t32 || $[144] !== t55) {
    t56 = /* @__PURE__ */ jsxs("div", { className: "graphiql-main", children: [
      t31,
      t32,
      t55
    ] });
    $[142] = t31;
    $[143] = t32;
    $[144] = t55;
    $[145] = t56;
  } else {
    t56 = $[145];
  }
  let t57;
  if ($[146] !== t29 || $[147] !== t56) {
    t57 = /* @__PURE__ */ jsxs("div", { className: "graphiql-body", children: [
      t29,
      t56
    ] });
    $[146] = t29;
    $[147] = t56;
    $[148] = t57;
  } else {
    t57 = $[148];
  }
  let t58;
  if ($[149] === Symbol.for("react.memo_cache_sentinel")) {
    t58 = /* @__PURE__ */ jsx(StatusBar, {});
    $[149] = t58;
  } else {
    t58 = $[149];
  }
  let t59;
  if ($[150] !== t27 || $[151] !== t28 || $[152] !== t57) {
    t59 = /* @__PURE__ */ jsxs("div", { ref: setContainerRef, className: t27, children: [
      t28,
      t57,
      t58
    ] });
    $[150] = t27;
    $[151] = t28;
    $[152] = t57;
    $[153] = t59;
  } else {
    t59 = $[153];
  }
  let t60;
  if ($[154] !== children || $[155] !== portalContainer || $[156] !== t59) {
    t60 = /* @__PURE__ */ jsx(Tooltip.Provider, { children: /* @__PURE__ */ jsxs(PortalProvider, { container: portalContainer, children: [
      t59,
      children
    ] }) });
    $[154] = children;
    $[155] = portalContainer;
    $[156] = t59;
    $[157] = t60;
  } else {
    t60 = $[157];
  }
  return t60;
};
function getChildComponentType(child) {
  if (child && typeof child === "object" && "type" in child && typeof child.type === "function") {
    return child.type;
  }
}
const GraphiQL = Object.assign(GraphiQL_, {
  Footer: GraphiQLFooter
});
function _temp(state) {
  return Boolean(state.monaco);
}
function _temp2(acc, curr) {
  bb44: switch (getChildComponentType(curr)) {
    case GraphiQL.Footer: {
      acc.footer = curr;
      break bb44;
    }
    default: {
      acc.children.push(curr);
    }
  }
  return acc;
}
function _temp3(plugin) {
  return plugin.sessionActions ? /* @__PURE__ */ jsx(plugin.sessionActions, {}, plugin.title) : null;
}
export {
  GraphiQL,
  GraphiQLInterface
};
//# sourceMappingURL=GraphiQL.js.map
